export const resolvePeriodLabel = (periodName: string | undefined, index: number) => {
  const customLabel = periodName?.trim()

  return customLabel || `Period ${index + 1}`
}
